import React from "react";
import AnimatedNumbers from "react-animated-numbers";
const AlphaherdSectionContentCard = ({
  subTitle,
  title,
  description,
  buttonText,
  counter,
  titleDivider,
}) => {
  return (
    <>
      <div className="hero_content">
        <div className="title_wrapper">
          {subTitle && (
            <div
              className="subTitle"
              data-aos="fade-up"
              data-aos-delay="500"
              data-aos-duration="5000"
              data-aos-once="true"
              data-aos-easing="ease-in-out"
            >
              <p>{subTitle}</p>
            </div>
          )}
          {title && (
            <div
              className="title"
              data-aos="fade-up"
              data-aos-delay="700"
              data-aos-duration="5000"
              data-aos-once="true"
              data-aos-easing="ease-in-out"
            >
              <h2>{title}</h2>
              {titleDivider && <span className="divider"></span>}
            </div>
          )}
        </div>
        {description && (
          <div
            className="description"
            data-aos="fade-up"
            data-aos-delay="900"
            data-aos-duration="5000"
            data-aos-once="true"
            data-aos-easing="ease-in-out"
          >
            <p>{description}</p>
          </div>
        )}
        {buttonText && (
          <div className="button_text">
            {buttonText.map((t, i) => (
              <button className={`${i + 1 === 1 ? "mint" : "dropdown"}`}>
                {t}
              </button>
            ))}
          </div>
        )}

        {counter && (
          <div className="counter_number">
            {counter.map((d, i) => (
              <div
                key={i + 1}
                className="counter_wrapper"
                data-aos="fade-up"
                data-aos-delay="800"
                data-aos-duration="5000"
                data-aos-once="true"
                data-aos-easing="ease-in-out"
              >
                <span className="count">
                  <AnimatedNumbers
                    includeComma
                    animateToNumber={d.number}
                    fontStyle={{ fontSize: 30 }}
                    configs={[
                      { mass: 1, tension: 220, friction: 100 },
                      { mass: 1, tension: 180, friction: 130 },
                      { mass: 1, tension: 280, friction: 90 },
                      { mass: 1, tension: 180, friction: 135 },
                      { mass: 1, tension: 260, friction: 100 },
                      { mass: 1, tension: 310, friction: 280 },
                    ]}
                  ></AnimatedNumbers>
                </span>
                <div className="text">{d.text}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default AlphaherdSectionContentCard;
